import * as constants from "../../constants";
import { Map } from "immutable";
import { mutateState } from "../../helpers/mutate-state";
import { IChangeStoreStateAction, IGetStoreSuccessAction, IStore, IAccountManager } from "../../types";
import {
  constructLoadingReducer,
  ILoadingReducerState,
} from "./constructLoadingReducer";

const STORE = "store";
const EDIT_FAILED = "editFailed";
const SAVED = "saved";
const SAVING = "saving";
const ACCOUNT_MANAGER = "accountManager";

export interface IStoreReducerState extends ILoadingReducerState {
  [STORE]: IStore;
  [EDIT_FAILED]: boolean;
  [SAVED]: boolean;
  [SAVING]: boolean;
  [ACCOUNT_MANAGER]: IAccountManager | null;
}

const initialState: IStoreReducerState = Map({
  [STORE]: {},
  [EDIT_FAILED]: false,
  [ACCOUNT_MANAGER]: null,
}).toJS();

const storeReducer = (
  state: IStoreReducerState,
  action: any
): IStoreReducerState => {
  switch (action.type) {
    case constants.getStoreAction.fulfilled: {
      const payload = (action as IGetStoreSuccessAction).payload;
      return mutateState(state, (map) => {
        map.set(STORE, payload.store);
        map.set(ACCOUNT_MANAGER, payload.account_manager || null);
      });
    }
    case constants.ACTION_CHANGE_STORE_STATE: {
      const payload = (action as IChangeStoreStateAction).payload;
      return mutateState(state, (map) => {
        map.set(STORE, payload);
      })
    }
    case constants.ACTION_RESET_EDIT_FAILED: {
      return mutateState(state, (map) => {
        map.set(EDIT_FAILED, false);
      });
    }
    case constants.editStoreAction.requested: {
      return mutateState(state, (map) => {
        map.set(SAVING, true);
        map.set(SAVED, false);
      });
    }
    case constants.editStoreAction.fulfilled: {
      return mutateState(state, (map) => {
        map.set(SAVING, false);
        map.set(SAVED, true);
      });
    }
    case constants.editStoreAction.rejected: {
      return mutateState(state, (map) => {
        map.set(EDIT_FAILED, true);
        map.set(SAVING, false);
        map.set(SAVED, false);
      });
    }
    default:
      return state;
  }
};

export default constructLoadingReducer(
  constants.getStoreAction,
  storeReducer as any,
  initialState
);
